<template>
    <div class="row wrap">
        <div class="col-6">
            <input-text :label="$t('Coord X')" v-model="label.x_coord" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text :label="$t('Coord Y')" v-model="label.y_coord" after="px" @change="label.save()"/>
        </div>
    </div>
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import {label} from "@/class/label";
    import InputColor from "@/modules/input/input-color";

    export default {
        name: "Hotspots_Edit",
        components: {InputColor, InputText},
        props: {
            label: {type: Object,default:() => new label()}
        },
    }
</script>